import React from "react";
import PropTypes from 'prop-types';
import { Stack } from "@mui/material";
import Icon from "../../../designSystem/atoms/Icon";
import Separator from "../../../designSystem/atoms/Separator";
import Typography from "../../../designSystem/atoms/Typography";
import OrderDetailsFooter from "../OrderDetailsFooter";

import "./OrderDetails.scss";

const OrderDetails = ({ iconSrc, fundName, footerProps }) => {
  return (
    <Stack className="oa-order-details">
      <Stack className="top-section">
        <Icon size="32px" src={iconSrc} dataAid="left"/>
        <Typography variant="body2" dataAid="title">
          {fundName}
        </Typography>
      </Stack>
      <Separator dataAid="1" />
      <OrderDetailsFooter {...footerProps} />
    </Stack>
  );
};

export default OrderDetails;

OrderDetails.propTypes = {
  iconSrc: PropTypes.string,
  fundName: PropTypes.string,
  footerProps : PropTypes.object
}